// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ErrorContainer,
.Notification-Wrapper {
  transition: max-height 0.5s ease-in-out;
}
.ErrorContainer:empty,
.Notification-Wrapper:empty {
  max-height: 0vh;
}
.ErrorContainer:not(:empty),
.Notification-Wrapper:not(:empty) {
  max-height: 100vh;
}
.ErrorContainer .toast,
.Notification-Wrapper .toast {
  height: inherit;
  line-height: 1.1rem;
  letter-spacing: 0.025rem;
  width: 100%;
  border: none;
  border-radius: 0;
  overflow: hidden;
  animation: expand 0.5s ease-in-out;
}
@keyframes expand {
  0% {
    max-height: 0;
  }
  100% {
    max-height: 5vh;
  }
}
.ErrorContainer .toast .Notification-Timestamp,
.Notification-Wrapper .toast .Notification-Timestamp {
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 0.875;
  white-space: nowrap;
}
.ErrorContainer .toast button,
.Notification-Wrapper .toast button {
  height: 2.5rem;
}
.ErrorContainer .toast:after,
.Notification-Wrapper .toast:after {
  content: "";
  display: block;
  width: 100%;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}
.ErrorContainer .toast .btn-link,
.Notification-Wrapper .toast .btn-link {
  color: inherit !important;
  transition: all 0.5s ease-in-out;
  font-size: 0.9rem;
  padding: 0;
  margin-top: 0.2rem;
}
.ErrorContainer .toast .btn-link:hover,
.Notification-Wrapper .toast .btn-link:hover {
  opacity: 75%;
}
.ErrorContainer .toast .toast-body,
.Notification-Wrapper .toast .toast-body {
  max-height: 5rem;
  overflow: auto;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}
.ErrorContainer .toast .toast-body > div,
.Notification-Wrapper .toast .toast-body > div {
  font-weight: 400;
}
.ErrorContainer .toast .toast-body .Notification-Info,
.ErrorContainer .toast .toast-body .Collapsible,
.Notification-Wrapper .toast .toast-body .Notification-Info,
.Notification-Wrapper .toast .toast-body .Collapsible {
  display: none;
}
.ErrorContainer .toast.bg-danger .toast-header,
.ErrorContainer .toast.bg-danger .toast-header .btn,
.ErrorContainer .toast.bg-danger .toast-body,
.ErrorContainer .toast.bg-danger .toast-body .btn, .ErrorContainer .toast.bg-success .toast-header,
.ErrorContainer .toast.bg-success .toast-header .btn,
.ErrorContainer .toast.bg-success .toast-body,
.ErrorContainer .toast.bg-success .toast-body .btn,
.Notification-Wrapper .toast.bg-danger .toast-header,
.Notification-Wrapper .toast.bg-danger .toast-header .btn,
.Notification-Wrapper .toast.bg-danger .toast-body,
.Notification-Wrapper .toast.bg-danger .toast-body .btn,
.Notification-Wrapper .toast.bg-success .toast-header,
.Notification-Wrapper .toast.bg-success .toast-header .btn,
.Notification-Wrapper .toast.bg-success .toast-body,
.Notification-Wrapper .toast.bg-success .toast-body .btn {
  color: #fff;
}
.ErrorContainer .toast.bg-danger .toast-header,
.ErrorContainer .toast.bg-danger .toast-body,
.Notification-Wrapper .toast.bg-danger .toast-header,
.Notification-Wrapper .toast.bg-danger .toast-body {
  background: var(--bs-red);
}
.ErrorContainer .toast.bg-success .toast-header,
.ErrorContainer .toast.bg-success .toast-body,
.Notification-Wrapper .toast.bg-success .toast-header,
.Notification-Wrapper .toast.bg-success .toast-body {
  background: var(--bs-green);
}
.ErrorContainer .toast.bg-secondary .toast-header,
.ErrorContainer .toast.bg-secondary .toast-body,
.Notification-Wrapper .toast.bg-secondary .toast-header,
.Notification-Wrapper .toast.bg-secondary .toast-body {
  color: #000;
  background: var(--bs-secondary);
}
.ErrorContainer .toast.bg-secondary .toast-header .btn-close::after,
.Notification-Wrapper .toast.bg-secondary .toast-header .btn-close::after {
  color: #000;
}
.ErrorContainer .toast.closing .toast-header,
.ErrorContainer .toast.closing .toast-body,
.Notification-Wrapper .toast.closing .toast-header,
.Notification-Wrapper .toast.closing .toast-body {
  position: relative;
  z-index: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/Notification/styles.scss"],"names":[],"mappings":"AAAA;;EAEE,uCAAA;AACF;AAAE;;EACE,eAAA;AAGJ;AADE;;EACE,iBAAA;AAIJ;AAFE;;EACE,eAAA;EACA,mBAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kCAAA;AAKJ;AAHI;EACE;IACE,aAAA;EAKN;EAHI;IACE,eAAA;EAKN;AACF;AAFI;;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AAKN;AAHI;;EACE,cAAA;AAMN;AAJI;;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,+CAAA;AAON;AALI;;EACE,yBAAA;EACA,gCAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;AAQN;AAPM;;EACE,YAAA;AAUR;AANI;;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AASN;AARM;;EACE,gBAAA;AAWR;AATM;;;;EAEE,aAAA;AAaR;AANQ;;;;;;;;;;;;;;;EAEE,WAAA;AAqBV;AAhBM;;;;EAEE,yBAAA;AAoBR;AAhBM;;;;EAEE,2BAAA;AAoBR;AAhBM;;;;EAEE,WAAA;EACA,+BAAA;AAoBR;AAjBQ;;EACE,WAAA;AAoBV;AAfM;;;;EAEE,kBAAA;EACA,YAAA;AAmBR","sourcesContent":[".ErrorContainer,\n.Notification-Wrapper {\n  transition: max-height 0.5s ease-in-out;\n  &:empty {\n    max-height: 0vh;\n  }\n  &:not(:empty) {\n    max-height: 100vh;\n  }\n  .toast {\n    height: inherit;\n    line-height: 1.1rem;\n    letter-spacing: 0.025rem;\n    width: 100%;\n    border: none;\n    border-radius: 0;\n    overflow: hidden;\n    animation: expand 0.5s ease-in-out;\n\n    @keyframes expand {\n      0% {\n        max-height: 0;\n      }\n      100% {\n        max-height: 5vh;\n      }\n    }\n\n    .Notification-Timestamp {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      line-height: 0.875;\n      white-space: nowrap;\n    }\n    button {\n      height: 2.5rem;\n    }\n    &:after {\n      content: '';\n      display: block;\n      width: 100%;\n      border-top: 1px solid rgba(255, 255, 255, 0.15);\n    }\n    .btn-link {\n      color: inherit !important;\n      transition: all 0.5s ease-in-out;\n      font-size: 0.9rem;\n      padding: 0;\n      margin-top: 0.2rem;\n      &:hover {\n        opacity: 75%;\n      }\n    }\n\n    .toast-body {\n      max-height: 5rem;\n      overflow: auto;\n      padding-top: 0.7rem;\n      padding-bottom: 0.7rem;\n      > div {\n        font-weight: 400;\n      }\n      .Notification-Info,\n      .Collapsible {\n        display: none;\n      }\n    }\n    &.bg-danger,\n    &.bg-success {\n      .toast-header,\n      .toast-body {\n        &,\n        .btn {\n          color: #fff;\n        }\n      }\n    }\n    &.bg-danger {\n      .toast-header,\n      .toast-body {\n        background: var(--bs-red);\n      }\n    }\n    &.bg-success {\n      .toast-header,\n      .toast-body {\n        background: var(--bs-green);\n      }\n    }\n    &.bg-secondary {\n      .toast-header,\n      .toast-body {\n        color: #000;\n        background: var(--bs-secondary);\n      }\n      .toast-header .btn-close {\n        &::after {\n          color: #000;\n        }\n      }\n    }\n    &.closing {\n      .toast-header,\n      .toast-body {\n        position: relative;\n        z-index: 500;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
